<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete :task-id="$_emWorkflowTaskMixin_taskId"
                                      syncValueChange
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      need-business-key
                                      useSelfCompleteTask
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
            <em-button type="downloadFile" @click="savePdf"
                       class="btn btn-outline-primary btn-sm position-absolute top right mt-1 mr-1"
                       style="z-index: 900"
                       v-if="!loadingPdf">
            </em-button>
        </section>
    </div>
</template>
<script>
// Author Lin
// Date 2021-05-16 19:04:44

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

export default {
    name: "sithMesInventoryAbnormalArrivalProcessWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    data() {
        return {
            htmlTitle: '导出PDF',
            loadingPdf: false
        }
    },
    methods: {
        savePdf() {
            this.loadingPdf = true;
            setTimeout(() => this.getPdf('#pdfDom'), 2000);
            setTimeout(() => this.loadingPdf = false, 5000);
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryAbnormalArrivalProcess/complete-feedback";
        },
        config() {
            return {
                'task1': {
                    name: '采购OM物流审核与反馈',
                    // approveLabel: '是否通过',
                    variables: [
                        {
                            label: '是否异常',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '确有异常'},
                                {value: 2, text: '无异常'}
                            ],
                        },
                        {
                            needTag: 'opinion',
                            label: '反馈信息',
                            name: 'feedback',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                        },
                        {
                            needTag: 'opinion',
                            label: '处理意见',
                            name: 'resolution',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: 1, text: '收货'},
                                {value: 2, text: '退货'}
                            ],
                        },
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        }
                    ],
                    changeTag: (businessData, approve) => {
                        return this.buildTag('opinion', approve === 1);
                    },
                    postDataByApprove() {
                        return {name: 'currentDateField', value: 'checkedTime'}
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task2_candidates',
                                allowMulti: true,
                                require: false
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task2',
                        2: 'reject',
                    }
                },
                'task2': {
                    name: '物流人员确认',
                    approveLabel: '是否同意',
                    variables: [
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        }
                    ],
                    postByApprove: (approve) => {
                        return {
                            url: process.env.VUE_APP_SITHMES_INVENTORY_URL + `/sithMesInventoryAbnormalArrivalProcess/recordCompleteTime?taskId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                    approveToNextTask: {
                        1: 'complete',
                        2: 'task1',
                    }
                },
                'reject': {
                    name: '驳回异常'
                },
                'complete': {
                    name: '流程结束'
                }
            }
        },
    }
};
</script>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>
